import React from "react";

import PropTypes from "prop-types";

const BaseOverlayModal = ({
    isVisible,
    setIsVisible,
    title,
    children,
    isLoading,
    contentStyles = {},
}) => {
    const closeModal = () => {
        setIsVisible && setIsVisible(false);
    };

    return (
        <>
            <div
                className={`modal overlay-modal  small-scroll-y ${
                    isVisible ? "show" : ""
                }`}
                id={`${title}-modal`}
            >
                <div
                    className={`modal-content-wrapper overlay-modal-content-wrapper shadow ${
                        isLoading ? "loading" : ""
                    }`}
                >
                    <div
                        style={contentStyles}
                        className={
                            "modal-content overlay-modal-content small-scroll-y overflow-auto"
                        }
                    >
                        {children}
                        <div className="text-right ml-auto mr-3 mt-3 text-black">
                            <i
                                onClick={closeModal}
                                className="fas fa-times fa-lg cursor-pointer"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

BaseOverlayModal.propTypes = {
    isVisible: PropTypes.bool.isRequired,
    setIsVisible: PropTypes.func.isRequired,

    children: PropTypes.node.isRequired,
    contentStyles: PropTypes.object,
};

export default BaseOverlayModal;
